export default function(nga, admin) {
    let entity = admin.getEntity('subscription')
        .updateMethod('patch')
        .label('Subscriptions');

    let pad = function (n, width, z) {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }

    entity.listView()
        .fields([
            nga.field('id').label('ID').isDetailLink(true),
            nga.field('code').label('CODE').isDetailLink(true),
            nga.field('purchase.order').label('ORDER').isDetailLink(true)
                .template('<entity-edit type="\'purchase\'" id="entry.values[\'purchase.id\']" text="value"></entity-edit>'),
            nga.field('type.name').label('TYPE').isDetailLink(true)
                .template('<entity-edit type="\'licencetype\'" id="entry.values[\'type.id\']" text="value"></entity-edit>'),
            nga.field('user').label(`USER`),
            nga.field('finalize', 'date').format('yyyy-MM-dd').label('EXPIRATE_AT'),

        ])
        .entryCssClasses(function(entry) {
            return (entry.subscription == 'active') ? 'success' : 'warning';
        })
        .sortDir('asc')
        .url('subscriptions')
        .prepare(['Restangular', 'datastore', 'entries', 'Entry', function(Restangular, datastore, entries, Entry){
            return Restangular
                .all('subscriptions/active')
                .getList({_sortDir: "ASC", _sortField: "finalize"})
                .then(data => {
                    data = data.data ? data.data : data;

                    entries.forEach(function(u, i){
                        u.values.subscription = 'inactive';

                        data.forEach(function(s, si){
                            if(u.values.id == s.id){
                                u.values.user = s.user.name+' '+ s.user.surname;
                                u.values.subscription = 'active';
                            }
                        });
                    })
                });
        }]);;

    entity.creationView().fields([
        nga.field('code'),
        nga.field('user', 'reference')
            .map(function(value, entry) {
                return entry['user.id'];
            })
            .targetEntity(nga.entity('user').url('users'))
            .targetField(nga.field('name').map(function (value, entry) {
                return entry['name'] + ' ' + (entry['surname'] || '');
            }))
            .perPage(0),
        nga.field('purchase', 'reference')
            .map(function(value, entry) {
                return entry['purchase.id'];
            })
            .targetEntity(nga.entity('purchase').url('purchases'))
            .targetField(nga.field('order').map(function (value, entry) {
                let date = ParseDate(entry['created']);
                if(date)
                    return date.getFullYear() + "" + date.getMonth() + "" + date.getDate() + "" + pad(entry['id'], 4);
            }))
            .perPage(0),
        nga.field('purchaseUser', 'reference')
            .map(function(value, entry) {
                return entry['purchase_user.id'];
            })
            .targetEntity(nga.entity('professional').url('professionals'))
            .targetField(nga.field('name').map(function (value, entry) {
                return entry['name'] + ' ' + (entry['surname'] || '');
            }))
            .perPage(0),
        nga.field('initialize', 'date').format('yyyy-MM-dd').map(ParseDate),
        nga.field('finalize', 'date').format('yyyy-MM-dd').map(ParseDate),
        nga.field('type', 'reference')
            .map(function(value, entry) {
                return entry['type.id'];
            })
            .targetEntity(nga.entity('licencetype').url('licencetypes'))
            .targetField(nga.field('name'))
            .perPage(0),
        nga.field('quantity', 'number')
    ]);


    var fields =  entity.creationView().fields();
    var fieldsEdit = [];

    for (var i = 0; i < fields.length; i++) {
        fieldsEdit[i] = fields[i];
    }
    fieldsEdit.pop();

    entity.editionView().fields(
        fieldsEdit
    );
    entity.deletionView();

    return entity;
}



/** WEBPACK FOOTER **
 ** ./js/entities/subscription/config.js
 **/